export const statuses = {
  open: {
    palette: {
      text: '#1F52B3',
      background: '#D8EFFE',
      border: '#8BC6FD',
    },
  },
  in_progress: {
    palette: {
      text: '#B09304',
      background: '#FEFACD',
      border: '#FCEB6A',
    },
  },
  paused: {
    palette: {
      text: '#6E7178',
      background: '#FAFBFF',
      border: '#DDE0E5',
    },
  },
  closed: {
    palette: {
      text: '#2E9B1E',
      background: '#ECFDD8',
      border: '#B4F389',
    },
  },
};

export const priorities = {
  low: {
    palette: {
      text: '#1C972B',
      background: '#E5FCD7',
      border: '#9EF187',
    },
  },
  medium: {
    palette: {
      text: '#B77413',
      background: '#FFF6D3',
      border: '#FFDC7C',
    },
  },
  high: {
    palette: {
      text: '#D46B08',
      background: '#FFF7E6',
      border: '#FFD591',
    },
  },
  critical: {
    palette: {
      text: '#B71F42',
      background: '#FFE4D8',
      border: '#FF9A8B',
    },
  },
};

type PriorityKey = keyof typeof priorities;
export const priorityList: PriorityKey[] = Object.keys(priorities) as PriorityKey[];

type StatusKey = keyof typeof statuses;
export const statusList: StatusKey[] = Object.keys(statuses) as StatusKey[];

export const GSheetType = 'gsheets';
export const CustomWebhookType = 'custom';

export interface priorityPaletteInterface {
  text: string;
  background: string;
  border: string;
}

export enum findingsTabs {
  inProgress = '1',
  closed = '2',
}

/** Page and shell background for the Findings (tickets) module */
export const findingsModuleBackground = '#FAFBFF';

/** Chip background (mandatory picker, add-tasks chips, etc.) */
export const findingsChipBackground = '#F0F5FF';

/** Default height for ticket-style chips in pickers (px) */
export const findingsChipHeightPx = 24;
